import Bottom from "./Bottom";
import Content from "./Content";
import NotFound from "./NotFound";
import Right from "./Right";
import VerifyEmail from "./VerifyEmail";

const quickShareDetailComponents = {
  Bottom,
  Content,
  NotFound,
  Right,
  VerifyEmail
}

export default quickShareDetailComponents